import { BaseWithId } from '@app/shared/models/base';
import { TranslationEntry } from '@app/shared/models/translatable';
import { Role } from '@app/core/authentication/permission';

export class UserRole extends BaseWithId implements TranslationEntry {

    public display_name: string;
    public role_id: Role;
    public system_role: boolean;

    get trans(): string {
        return this.display_name;
    }

    get key(): string {
        return this.role_id;
    }

    constructor(json?: any) {
        super(json);
    }
}
